import { z } from 'zod';

export const dedupClipsResponseSchema = z.object({
  deleted: z.number(),
});

export type IDedupClipsResponse = z.infer<typeof dedupClipsResponseSchema>;
